<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="height: 10px"></div>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        highlight-current-row
        stripe
        :header-cell-style="{textAlign: 'center'}"
        :cell-style="{textAlign: 'center'}"
        :height="maxTableHeight + 42"
        v-loading="loading"
      >
        <el-table-column label="修片类型" prop="retouchType"></el-table-column>
        <el-table-column label="折算后数量: 张" prop="estimate"></el-table-column>
        <el-table-column label="更新时间" prop="lastUpdateDate"></el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template> -->
    </table-panel>

    <edit-dialog
      ref="content"
      :visible.sync="isShowEdit"
      :rowData="rowData"
      @success="onSearch"
      v-if="isShowEdit"
    ></edit-dialog>
  </div>
</template>

<script>
import editDialog from "./components/edit";
import tableMixin from "@/utils/tableMixin";

export default {
  mixins: [tableMixin],
  components: { editDialog },
  data() {
    return {
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      isShowEdit: false,
      rowData: {},
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      this.$q.newProduct.queryWorkloadCalculates()
        .then((res) => {
          if (res.code == 200) {
            this.tableData.list = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // // 分页器 pagesize
    // handleSizeChange(val) {
    //   this.tableData.pageSize = val;
    //   this.tableData.pageNum = 1;
    //   this.init();
    // },
    // // 分页器 pageNum
    // handleCurrentChange(val) {
    //   this.tableData.pageNum = val;
    //   this.init();
    // },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = {...row};
      this.isShowEdit = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
